import React, { useState } from "react";
import { Row, Table } from "antd";

import SectionCard from "components/SectionCard/SectionCard";
import SectionContainer from "components/SectionContainer/SectionContainer";
import { constructDisplayPrice } from "utils/general";

import AddFundDistributionModal from "../AddFundDistributionModal/AddFundDistributionModal";
import Locale from "react-intl-universal";

const constructFundDistributionsTableColumns = () => [
  {
    dataIndex: "type",
    key: "type",
  },
  {
    dataIndex: "amount",
    key: "amount",
    render: (value) => constructDisplayPrice(value || 0, false),
  },
];

const FundDistribution = ({ investmentFunds = [], updateInvestmentFunds }) => {
  const [showFundDistributionModal, setShowFundDistributionModal] = useState(
    false
  );
  const [
    selectedInvestmentFundIndex,
    setSelectedInvestmentFundIndex,
  ] = useState(-1);

  const handleOnFundDistributionRowSelect = (index) => {
    setShowFundDistributionModal(true);
    setSelectedInvestmentFundIndex(index);
  };

  const handleOnAddFundDistributionModalOkButtonClick = (
    newFundDistribution
  ) => {
    let newFundDistributions = [...investmentFunds];
    if (selectedInvestmentFundIndex > -1) {
      newFundDistributions[selectedInvestmentFundIndex] = newFundDistribution;
    } else {
      newFundDistributions = [...investmentFunds, newFundDistribution];
    }
    updateInvestmentFunds(newFundDistributions);
    setShowFundDistributionModal(false);
    setSelectedInvestmentFundIndex(-1);
  };

  const handleOnAddFundDistributionModalRemoveButtonClick = () => {
    const newFundDistributions = [...investmentFunds];
    newFundDistributions.splice(selectedInvestmentFundIndex, 1);
    setShowFundDistributionModal(false);
    updateInvestmentFunds(newFundDistributions);
    setSelectedInvestmentFundIndex(-1);
  };

  const handleOnAddFundDistributionModalCloseButtonClick = () => {
    setShowFundDistributionModal(false);
    setSelectedInvestmentFundIndex(-1);
  };

  return (
    <>
      <SectionContainer>
        <SectionCard
          title={Locale.get(
            "ownedPolicies.fundDistributionTab.fundDistribution"
          )}
          buttonText={Locale.get(
            "ownedPolicies.fundDistributionTab.fundDistributionButton"
          )}
          onActionButtonClick={() => setShowFundDistributionModal(true)}
        >
          <Row gutter={16}>
            <Table
              dataSource={investmentFunds}
              columns={constructFundDistributionsTableColumns()}
              pagination={false}
              rowKey={(record) => record.name}
              showHeader={false}
              style={{ width: "100%" }}
              onRow={(record, index) => {
                return {
                  onClick: () => handleOnFundDistributionRowSelect(index),
                };
              }}
            />
          </Row>
        </SectionCard>
      </SectionContainer>
      {showFundDistributionModal && (
        <AddFundDistributionModal
          defaultValues={
            selectedInvestmentFundIndex > -1 &&
            investmentFunds[selectedInvestmentFundIndex]
          }
          onClose={handleOnAddFundDistributionModalCloseButtonClick}
          onOk={handleOnAddFundDistributionModalOkButtonClick}
          onRemove={handleOnAddFundDistributionModalRemoveButtonClick}
          visible={showFundDistributionModal}
        />
      )}
    </>
  );
};

export default FundDistribution;
